//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data () {
    return {
      squaresNum: 4
    }
  },

  computed: {
    spinnerStyle () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
        animationDuration: `${this.animationDuration}ms`
      }
    },

    squareStyle () {
      return {
        height: `${this.size * 0.25 / 1.3}px`,
        width: `${this.size * 0.25 / 1.3}px`,
        animationDuration: `${this.animationDuration}ms`,
        borderWidth: `${this.size * 0.04 / 1.3}px`,
        borderColor: this.color
      }
    },

    squaresStyles () {
      const squaresStyles = []

      for (let i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(Object.assign({
        }, this.squareStyle))
      }

      return squaresStyles
    }
  }
}
